import ICSButton from '../../components/ICS/Button/ICSButton'

const AcceptableUsagePolicy = ({
  policy,
  accept
}) => {
  return (
    <>
      <div style={{ whiteSpace: 'pre-wrap' }}>{policy}</div>
       <ICSButton
          id='Acceptable_Usage_Policy'
          width={60}
          useSubmitBehavior={true}
          type='success'
          onClick={accept}
        >
          Accept
        </ICSButton>
    </>
  )
}

export default AcceptableUsagePolicy